import LayoutPage from "@/views/shared/LayoutPage";

export default [
  {
    path: "/supplier",
    component: LayoutPage,
    children: [
      {
        path: "",
        name: "supplier-page",
        component: () => import("../../views/Supplier/SupplierPage.vue"),
        meta: {
          title: "Supplier",
          titleLocalizationCode: "Supplier",
          desc: "Supplier page",
          descLocalizationCode: "Supplier_Page",
          sidebarElement: false,
          permissionCodes: [
            "Supplier.Read",
            "Supplier.Add",
            "Supplier.Edit",
            "Supplier.Delete",
          ],
        },
      },
    ],
  },
];
